import { getTravelerInitials } from '@eti/utils';
import { insertArgument } from '@eti/utils/dist/string/string';
const getCurrentTravelers = (travelers, travelerFormNames, defaultTravelerLabel, travelerFormData) => {
  return travelers.map(traveler => {
    const currentTravelerNames = travelerFormNames.find(travelerFormName => travelerFormName.travelerId === traveler.id);
    const gender = traveler.id != null ? travelerFormData[Number(traveler.id)] : {};
    return {
      name: currentTravelerNames ? currentTravelerNames.fullName : insertArgument(defaultTravelerLabel, Number(traveler.id) + 1),
      id: Number(traveler.id),
      ageType: traveler.ageType,
      initials: (currentTravelerNames === null || currentTravelerNames === void 0 ? void 0 : currentTravelerNames.initials) || '',
      ...gender
    };
  });
};
export const getTravelers = (order, travelerFormNames, defaultTravelerLabel, travelerFormData) => {
  return order.availableExtraProducts ? order.travelers.map(_ref => {
    let {
      id,
      ...traveler
    } = _ref;
    return {
      ...traveler,
      ...(id ? {
        id: Number(id)
      } : {}),
      initials: getTravelerInitials(traveler.firstName, traveler.lastName),
      name: traveler.fullName
    };
  }) : getCurrentTravelers(order.travelers, travelerFormNames, defaultTravelerLabel, travelerFormData);
};
//# sourceMappingURL=seatMapContainerUtils.js.map